export const PERFORMANCE_PERIOD_FILTER_KEY = 'period';

export const PERFORMANCE_COUNT_KEYS = [
  'feedback_count',
  'one_on_one_count',
  'performance_improvement_count',
  'verbal_warning_count',
  'disciplinary_action_count',
  'annual_review_count',
];

export interface PerformanceFilterEntry {
  key: string;
  value: any;
}

export interface PerformancePeriodSelection {
  startDate: string;
  endDate: string;
}

export const extractPerformancePeriod = (filters: PerformanceFilterEntry[]): PerformancePeriodSelection => {
  const period = (filters || []).find((filter) => filter?.key === PERFORMANCE_PERIOD_FILTER_KEY)?.value;

  if (!period || typeof period !== 'object') {
    return { startDate: '', endDate: '' };
  }

  return { startDate: String(period.from || ''), endDate: String(period.to || '') };
};

export const countFiltersOnly = (filters: PerformanceFilterEntry[]): PerformanceFilterEntry[] =>
  (filters || []).filter((filter) => filter?.key !== PERFORMANCE_PERIOD_FILTER_KEY);

export const sumPerformanceCounts = (rows: any[]): Record<string, number> =>
  PERFORMANCE_COUNT_KEYS.reduce((totals: Record<string, number>, key: string) => {
    totals[key] = (rows || []).reduce((sum: number, row: any) => sum + (Number(row?.[key]) || 0), 0);
    return totals;
  }, {});
